import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { ClickAwayListener, IconButton } from '@mui/material';
import React, { useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useTranslation } from '../../services/translation/hooks/useTranslation';
import { Tooltip } from '../../sprouts/components/Tooltip/Tooltip';

interface CopyButtonProps {
  textToCopy: string;
  format?: 'text/plain'; // default is 'text/html' but 'text/plain' is needed for CSV to paste into google sheets properly
  hoverText?: string; // Custom tooltip text to show on hover
  copiedText?: string; // Custom text to show after copying
}

const CopyButton: React.FC<CopyButtonProps> = ({
  textToCopy,
  format,
  hoverText = 'Copy',
  copiedText = 'Copied',
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setOpen(true);
    setTimeout(() => setOpen(false), 1200);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const displayedText = open ? copiedText : hoverText;

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <Tooltip
        open={open || undefined}
        onClose={handleClose}
        title={t(displayedText)}
        placement='top'
      >
        <div>
          <CopyToClipboard
            text={textToCopy}
            options={format ? { format: format } : undefined}
          >
            <IconButton onClick={handleClick} size='small'>
              <ContentCopyIcon sx={{ fill: 'white' }} fontSize='inherit' />
            </IconButton>
          </CopyToClipboard>
        </div>
      </Tooltip>
    </ClickAwayListener>
  );
};

export default CopyButton;
